import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';
import { cn } from '@library/component-utils/cn';

interface ProgressBarProps {
  className?: string; // eslint-disable-line react/require-default-props
  progressBarColor?: string; // eslint-disable-line react/require-default-props
  value: number;
}

const ProgressBar = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressBarProps
>(
  (
    { className = '', progressBarColor = 'bg-soClean-100', value, ...props },
    ref
  ) => {
    const progressColor = value >= 100 ? 'bg-status-failure' : progressBarColor;
    return (
      <ProgressPrimitive.Root
        ref={ref}
        className={cn(
          'bg-soFresh-140 relative h-3 overflow-hidden rounded-full',
          className
        )}
        {...props}
      >
        <ProgressPrimitive.Indicator
          className={cn(`${progressColor} size-full flex-1 transition-all`)}
          style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        />
      </ProgressPrimitive.Root>
    );
  }
);
ProgressBar.displayName = ProgressPrimitive.Root.displayName;

export { ProgressBar };
